@if (components.length) {
    <!-- The same info icon as Storage Fees in the order summary. -->
    <img src="/assets/admin/images/info-circle-icon.svg" width="20" height="20" alt="info-circle-icon"
         class="cursor-pointer unit-card-info" [class.unit-card-info-dark]="dark"
         [tooltip]="unitComponentsTpl" container="body" containerClass="unit-tip-container" [placement]="'top'" />

    <ng-template #unitComponentsTpl>
        <!--
          A table, not prose. The figures an admin needs have to line up in fixed columns to be
          readable; in a sentence they land in a different place on every row.
        -->
        <div class="unit-tip">
            <!--
              Stock On Hand: what the parts left here can build — the card's Available, worked out as a
              normal product's.
              A container: everything it assembles — its Total (Allocated + Available) — which is
              what the table below works out, so allocating to the container leaves both unchanged.
            -->
            <p class="unit-tip-head">
                @if (isWarehouse) {
                    Can build
                    <strong>{{ card?.available_qty | number: '1.2-2' }} {{ uom }}</strong>
                    <!-- Units already built count without parts, so the table below explains the rest. -->
                    @if (card?.finished_units > 0) {
                        <span class="unit-tip-ref">incl. {{ card.finished_units | number: '1.2-2' }} built</span>
                    }
                } @else {
                    Assembles
                    <strong>{{ card?.total_qty | number: '1.2-2' }} {{ uom }}</strong>
                }
            </p>
            <table class="unit-tip-table">
                <thead>
                    <tr>
                        <th>Component</th>
                        <!-- The recipe ratio, and the reason the rows are in this order. -->
                        <th class="ta-right">Per {{ uom }}</th>
                        @if (isWarehouse) {
                            <!-- Unleashed's stock on hand for the part, as it is. -->
                            <th class="ta-right">Stock On Hand</th>
                            <!-- Every order allocated to the part here: this product's, other products', part sales. -->
                            <th class="ta-right">Allocated</th>
                            <th class="ta-right">Available</th>
                            <!-- Available ÷ Per: the smallest is the card's figure. -->
                            <th class="ta-right">Can build</th>
                        } @else {
                            <th class="ta-right">From earlier</th>
                            <th class="ta-right">This container</th>
                            <th class="ta-right">Total</th>
                        }
                        <!--
                          What is left once this card has assembled its units: where the next container starts.
                          Shown on every card, the last one included (0.00 when nothing is left), so every
                          table reads the same way.
                        -->
                        <th class="ta-right">Carried forward</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of rows; track row.id) {
                        <tr [class.unit-tip-limits]="row.isLimiting">
                            <td>
                                {{ row.sku }}
                                <!-- On every row but drawn only on the limiting one, so the column keeps its width whichever part limits. -->
                                <span class="unit-tip-flag" [class.unit-tip-flag-hidden]="!row.isLimiting"
                                      [attr.aria-hidden]="row.isLimiting ? null : 'true'">limits</span>
                            </td>
                            <td class="ta-right">{{ row.perUnit | number: '1.0-4' }}</td>
                            @if (isWarehouse) {
                                <td class="ta-right">{{ row.onHand | number: '1.2-2' }}</td>
                                <td class="ta-right">{{ row.allocated | number: '1.2-2' }}</td>
                                <td class="ta-right" [class.unit-tip-negative]="row.shelfAvailable < 0">{{ row.shelfAvailable | number: '1.2-2' }}</td>
                                <td class="ta-right" [class.unit-tip-negative]="row.canBuild < 0">{{ row.canBuild | number: '1.2-2' }}</td>
                            } @else {
                                <!--
                                  A dash means EXACTLY nothing, never a negative.
                                  "From earlier" goes negative when earlier stock
                                  is oversubscribed, and hiding that behind a dash
                                  made the row stop adding up: 96.00 + — = 60.20.
                                -->
                                <td class="ta-right" [class.unit-tip-negative]="row.earlierQty < 0">{{ row.earlierQty === 0 ? '-' : (row.earlierQty | number: '1.2-2') }}</td>
                                <td class="ta-right">{{ row.hereQty === 0 ? '-' : (row.hereQty | number: '1.2-2') }}</td>
                                <td class="ta-right">{{ row.totalQty | number: '1.2-2' }}</td>
                            }
                            <td class="ta-right unit-tip-covers" [class.unit-tip-negative]="row.carriedForward < 0">{{ row.carriedForward | number: '1.2-2' }}</td>
                        </tr>
                    }
                </tbody>
            </table>
            <!-- What the three stock columns mean, on the Stock On Hand card where they appear. -->
            @if (isWarehouse) {
                <p class="unit-tip-note">
                    <strong>Stock On Hand:</strong> in Unleashed.
                    <strong>Allocated:</strong> orders on Stock On Hand, and despatched orders Unleashed has not completed.
                    <strong>Available:</strong> Stock On Hand − Allocated.
                </p>
            }
        </div>
    </ng-template>
}
